/**
 * Turning the service worker on, and being able to turn it off again.
 *
 * A service worker is the one thing in a web app that can outlive a bad
 * deploy: get it wrong and every returning visitor is served a broken copy
 * from their own device, with no way for you to reach them. So the escape
 * hatch is built at the same time as the thing it rescues — ?nosw=1 tears it
 * all down, and that URL is worth remembering.
 *
 * Development is left alone entirely. A worker caching a dev server is a
 * fantastic way to spend an afternoon debugging a file you already fixed.
 */

const KILL_SWITCH = "nosw";

export async function unregisterAll() {
  if (!("serviceWorker" in navigator)) return;
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.all(regs.map((r) => r.unregister()));
  if (window.caches) {
    const names = await caches.keys();
    await Promise.all(names.map((n) => caches.delete(n)));
  }
}

export default function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  if (new URLSearchParams(window.location.search).has(KILL_SWITCH)) {
    unregisterAll();
    return;
  }

  // After load: registering during it competes with the page for the network
  // on exactly the connections this is meant to help.
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* No offline support this visit. Everything else still works. */
    });
  });
}
